import { css } from '@lastbrand/web-ui-styled-system/css'

import type { SystemStyleObject } from '@lastbrand/web-ui-styled-system/types'

// Panda twin of readMore.module.scss `.container` — the legacy block is mobile-only
// (`display: none` on desktop, `display: block` under `mobileOnly`). This component owns
// `display` exclusively; callers supply typography/spacing via `className` so two classes never
// fight over the same property (an atomic-CSS class-order race — see ds-migration.md).
export const containerCss = css({
  display: 'block',
})

// Passed to web-ui TextLink's `css` prop, which takes a raw SystemStyleObject, not a compiled
// class string.
export const toggleLinkStyle: SystemStyleObject = {
  cursor: 'pointer',
  paddingBlock: 0,
}
